import { render, staticRenderFns } from "./ClaimDetails.vue?vue&type=template&id=314cae7c&scoped=true&lang=pug&"
import script from "./ClaimDetails.vue?vue&type=script&lang=js&"
export * from "./ClaimDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDetails.vue?vue&type=style&index=0&id=314cae7c&prod&lang=scss&"
import style1 from "./ClaimDetails.vue?vue&type=style&index=1&id=314cae7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314cae7c",
  null
  
)

export default component.exports